export type ResearchReportReadResult =
  | { kind: 'inline'; content: string }
  | { kind: 'remote'; url: string }
  | { kind: 'notText' }
  | null
  | undefined;

export type ResearchReportMarkdownSource =
  | { kind: 'loading' }
  | { kind: 'inline'; text: string }
  | { kind: 'remote'; url: string }
  | { kind: 'error' };

export const resolveResearchReportMarkdownSource = (args: {
  readResult: ResearchReportReadResult;
  legacyUrl?: string | null;
  queryEnabled: boolean;
}): ResearchReportMarkdownSource => {
  if (!args.queryEnabled) {
    return args.legacyUrl
      ? { kind: 'remote', url: args.legacyUrl }
      : { kind: 'error' };
  }

  if (args.readResult === undefined) return { kind: 'loading' };
  if (args.readResult?.kind === 'inline') {
    return { kind: 'inline', text: args.readResult.content };
  }
  if (args.readResult?.kind === 'remote') {
    return { kind: 'remote', url: args.readResult.url };
  }
  return { kind: 'error' };
};
